import { Section } from 'Container';
import styled from 'styled-components';
import { breakpoints, colors } from 'components/Theme';
import { asRem } from 'utils';

export const HealthInsuranceSectionStyle = styled(Section)`
  padding-bottom: ${asRem(40)};

  .content {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .btn-row {
    display: flex;
    flex-direction: column-reverse;

    @media (min-width: ${breakpoints.lg}) {
      flex-direction: row;
    }
  }

  .button {
    background-color: ${colors.pink.c600};
    margin-top: ${asRem(10)};
    @media (min-width: ${breakpoints.lg}) {
      margin-top: 0;
      margin-right: ${asRem(20)};
    }
  }

  .btn-pink600 {
    background-color: ${colors.pink.c600};
  }

  .health-image-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;

    @media (min-width: ${breakpoints.md}) {
      flex-direction: column;
    }
  }

  .health-image {
    width: 100%;
    height: auto;
    margin-bottom: ${asRem(24)};
    object-fit: contain;

    @media (min-width: ${breakpoints.md}) {
      max-height: ${asRem(280)};
      aspect-ratio: auto;
      align-self: center;
      margin-top: ${asRem(24)};
      margin-bottom: 0;
    }
  }
`;
